import { query, subst } from 'urlcat'
import { toValue } from 'vue'
import { deepUnref } from 'vue-deepunref'

/**
 * Wrapper around urlcat's query that handles reactive params
 * @see https://urlcat.org/#/?id=query-build-query-strings
 *
 * @param {Object} params A map of key/value pairs. Values can be refs.
 * @returns {string} The concatenated query string
 */
export const urlQuery = (params) => query(deepUnref(params))

/**
 * Wrapper around urlcat's subst that handles reactive urls and params
 * @see https://urlcat.org/#/?id=subst-substitute-path-parameters
 *
 * @param {string|Ref<string>} url A URL template with one or more placeholders (starting with colon).
 * @param {Object} params A map of placeholder names to their values. Values can be refs.
 * @returns {string} The URL with substituted placeholders
 */
export const urlSubst = (url, params) => subst(toValue(url), deepUnref(params))
